import React, { forwardRef } from 'react';
import { classNames } from '../helpers/functions';

const Item = forwardRef(
	({ id, children, index, style, faded, ...props }, ref) => {
		const inlineStyles = {
			opacity: faded ? '0.2' : '1',
			transformOrigin: '0 0',
			height: index === 0 ? 410 : 200,
			gridRowStart: index === 0 ? 'span 2' : null,
			gridColumnStart: index === 0 ? 'span 2' : null,
			...style,
		};

		return (
			<div
				style={inlineStyles}
				{...props}
				ref={ref}
				className={classNames(
					index === 0 || index === 1 ? 'col-span-2' : '',
					'border-dashed border rounded'
				)}
			>
				{id}
			</div>
		);
	}
);

export default Item;
